import {
    ApplicationRef,
    ComponentFactoryResolver,
    ComponentRef,
    Injectable,
    Injector,
    Type,
} from '@angular/core';
import { CollapsedSidepanelComponent } from './collapsed-sidepanel.component';
import { RoblexCollapsedSidepanelModule } from './collapsed-sidepanel.module';
import {
    RoblexCollapsedSidepanelConfig,
    RoblexCollapsedSidepanelInjector,
    RoblexCollapsedSidepanelRef,
} from '../../config';
import { ElementService } from '../../providers/element.service';

@Injectable({
    providedIn: RoblexCollapsedSidepanelModule,
})
export class RoblexCollapsedSidepanelService {
    /**
     * Components references of neyhaz modal service
     */
    componentsReferences = Array<ComponentRef<CollapsedSidepanelComponent>>();
    /**
     * Creates an instance of roblex collapsed sidepanel service.
     * @param componentFactoryResolver ComponentFactoryResolver
     * @param appRef ApplicationRef
     * @param injector Injector
     */
    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private appRef: ApplicationRef,
        private injector: Injector,
        private elementService: ElementService
    ) {
        this.elementService.animateName = 'disapearX';
    }
    /**
     * Shows roblex collapsed sidepanel service
     * @param [config] RoblexCollapsedSidepanelConfig
     */
    show<T>(componentType: Type<T>, config?: RoblexCollapsedSidepanelConfig) {

        const map = new WeakMap();
        map.set(RoblexCollapsedSidepanelConfig, Object.assign({ backdrop: true }, config),);

        const dialogRef = new RoblexCollapsedSidepanelRef();
        map.set(RoblexCollapsedSidepanelRef, dialogRef);

        const componentRef = this.elementService.appendDialogComponentToBody(
            this.appRef,
            new RoblexCollapsedSidepanelInjector(this.injector, map),
            CollapsedSidepanelComponent,
            ['collapsed-sidepanel-open']
        );
        const component = componentRef.instance;
        // component.uniqueKey = ++this.childUniqueKey;
        component.childComponentType = componentType;
        /**
         * Remove modal component of body
         */
        const sub = dialogRef.afterClosed.subscribe((res) => {
            this.elementService.removeModalComponentFromBody(
                this.appRef,
                this.componentsReferences,
                component.uniqueKey,
                'collapsed-sidepanel-open',
                'collapsed-sidepanel-remove'
            );
            sub.unsubscribe();
        });
        this.componentsReferences.push(componentRef);
        return componentRef;
    }
}
